/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Capacitor injects `window.Capacitor` even into web builds depending on
// configuration, so checking `window.Capacitor` is unreliable. The build's
// VUE_APP_PLATFORM env var is the source of truth ("web", "android", "ios").
const isWeb = process.env.VUE_APP_PLATFORM === 'web';

// Only register service worker in production web builds — Capacitor mobile
// builds use the native shell, not the SW.
if (process.env.NODE_ENV === 'production' && isWeb) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      // A new service worker is waiting to activate. By default workbox waits
      // until ALL tabs of the app close before swapping — that can take days
      // for PWA-installed users. We instead activate immediately and reload
      // the page so the user runs the new code on the next page paint.
      //
      // This matters for the PayPal recharge flow specifically: a stale-cached
      // client that initiates a PayPal payment without the new intent contract
      // would hit a silent failure (the new strict backend rejects the legacy
      // request shape).
      try {
        if (registration && registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        }
      } catch (e) {
        console.error('SKIP_WAITING postMessage failed:', e)
      }

      // When the new SW takes control, reload so the page picks up the new
      // precached bundles. controllerchange fires once skipWaiting completes.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Avoid reload loops: only reload if we haven't already this load.
        if (window.__riwaqReloadedForNewSw) return
        window.__riwaqReloadedForNewSw = true
        window.location.reload()
      })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
} else if (!isWeb) {
  console.log(`Platform is "${process.env.VUE_APP_PLATFORM}" - Service Worker registration skipped.`)
}
